import * as React from "react";
import Box from "@mui/material/Box";
import { Button, Dialog, Typography } from "@mui/material";
import NewEmployee from "./newEmployee";
import NewDpt from "./new_dpt";
import { useNavigate } from "react-router-dom";

export default function SimplePaper() {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [isDialogDpt, setIsDialogDpt] = React.useState(false);

  const navigate = useNavigate();

  const OpenEmployee = () => {
    setIsDialogOpen(true);
  };

  const CloseEmployee = () => {
    setIsDialogOpen(false);
  };
  const OpenDpt = () => {
    setIsDialogDpt(true);
  };

  const CloseDpt = () => {
    setIsDialogDpt(false);
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        paddingX: 1,
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
      }}
    >
      <Button
        variant="contained"
        sx={{
          padding: 0,
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          paddingBottom: 1,
          paddingTop: 1,
          paddingLeft: 0.5,
          paddingRight: 0.5,
          marginTop: 2,
          marginBottom: 1,
          width: 160,
          "&:hover": {
            backgroundColor: "#A0E295",
          },
        }}
        onClick={OpenDpt}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_135_22306)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15 5.99987C15.0002 6.62048 14.808 7.22589 14.4498 7.73272C14.0916 8.23954 13.5851 8.62286 13 8.82987V10.9999H16C16.7957 10.9999 17.5587 11.3159 18.1214 11.8785C18.684 12.4412 19 13.2042 19 13.9999V15.1699C19.6675 15.4058 20.2301 15.8701 20.5884 16.4807C20.9467 17.0913 21.0775 17.8089 20.9578 18.5067C20.8382 19.2044 20.4757 19.8374 19.9344 20.2937C19.3931 20.7501 18.708 21.0004 18 21.0004C17.2921 21.0004 16.6069 20.7501 16.0657 20.2937C15.5244 19.8374 15.1619 19.2044 15.0422 18.5067C14.9225 17.8089 15.0534 17.0913 15.4117 16.4807C15.7699 15.8701 16.3325 15.4058 17 15.1699V13.9999C17 13.7346 16.8947 13.4803 16.7071 13.2928C16.5196 13.1052 16.2652 12.9999 16 12.9999H8.00003C7.73481 12.9999 7.48046 13.1052 7.29292 13.2928C7.10539 13.4803 7.00003 13.7346 7.00003 13.9999V15.1699C7.66752 15.4058 8.23012 15.8701 8.58839 16.4807C8.94666 17.0913 9.07752 17.8089 8.95784 18.5067C8.83817 19.2044 8.47566 19.8374 7.9344 20.2937C7.39314 20.7501 6.70798 21.0004 6.00003 21.0004C5.29208 21.0004 4.60692 20.7501 4.06566 20.2937C3.5244 19.8374 3.16189 19.2044 3.04222 18.5067C2.92254 17.8089 3.0534 17.0913 3.41167 16.4807C3.76994 15.8701 4.33254 15.4058 5.00003 15.1699V13.9999C5.00003 13.2042 5.3161 12.4412 5.87871 11.8785C6.44132 11.3159 7.20438 10.9999 8.00003 10.9999H11V8.82987C10.4812 8.6467 10.0227 8.32441 9.67464 7.89823C9.3266 7.47206 9.10243 6.9584 9.02664 6.41341C8.95084 5.86842 9.02634 5.31308 9.24488 4.80811C9.46342 4.30314 9.81658 3.86797 10.2658 3.55017C10.7149 3.23238 11.2428 3.04419 11.7918 3.00619C12.3407 2.96819 12.8895 3.08183 13.3782 3.3347C13.8669 3.58756 14.2766 3.96992 14.5627 4.43996C14.8487 4.91 15 5.44963 15 5.99987ZM12 4.99987C11.7348 4.99987 11.4805 5.10522 11.2929 5.29276C11.1054 5.4803 11 5.73465 11 5.99987C11 6.26508 11.1054 6.51944 11.2929 6.70697C11.4805 6.89451 11.7348 6.99987 12 6.99987C12.2652 6.99987 12.5196 6.89451 12.7071 6.70697C12.8947 6.51944 13 6.26508 13 5.99987C13 5.73465 12.8947 5.4803 12.7071 5.29276C12.5196 5.10522 12.2652 4.99987 12 4.99987ZM6.00003 16.9999C5.73481 16.9999 5.48046 17.1052 5.29292 17.2928C5.10539 17.4803 5.00003 17.7346 5.00003 17.9999C5.00003 18.2651 5.10539 18.5194 5.29292 18.707C5.48046 18.8945 5.73481 18.9999 6.00003 18.9999C6.26525 18.9999 6.5196 18.8945 6.70714 18.707C6.89467 18.5194 7.00003 18.2651 7.00003 17.9999C7.00003 17.7346 6.89467 17.4803 6.70714 17.2928C6.5196 17.1052 6.26525 16.9999 6.00003 16.9999ZM18 16.9999C17.7348 16.9999 17.4805 17.1052 17.2929 17.2928C17.1054 17.4803 17 17.7346 17 17.9999C17 18.2651 17.1054 18.5194 17.2929 18.707C17.4805 18.8945 17.7348 18.9999 18 18.9999C18.2652 18.9999 18.5196 18.8945 18.7071 18.707C18.8947 18.5194 19 18.2651 19 17.9999C19 17.7346 18.8947 17.4803 18.7071 17.2928C18.5196 17.1052 18.2652 16.9999 18 16.9999Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_135_22306">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <Typography
          fontSize={10}
          fontWeight="bold"
          color="black"
          sx={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Nouveau départmeent
        </Typography>
      </Button>
      <Dialog
        className="editDialog"
        sx={{ maxWidth: "100%" }}
        open={isDialogDpt}
        onClose={CloseDpt}
      >
        <NewDpt onCancel={CloseDpt} />
      </Dialog>
      <Button
        variant="contained"
        sx={{
          padding: 0,
          borderRadius: "20px",
          paddingBottom: 1,
          paddingTop: 1,
          paddingLeft: 0.5,
          paddingRight: 0.5,
          backgroundColor: "#ffffff",
          marginTop: 1,
          marginBottom: 1,
          width: 160,
          "&:hover": {
            backgroundColor: "#A0E295",
          },
        }}
        onClick={() => navigate("/add-restaurant")}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_333_6881)">
            <path
              d="M3.14396 2.61084L23.2925 22.7594C23.6748 23.1417 23.8896 23.6602 23.8896 24.2009C23.8896 24.7416 23.6748 25.2601 23.2925 25.6425C22.9101 26.0247 22.3915 26.2393 21.8509 26.2393C21.3103 26.2393 20.7918 26.0247 20.4093 25.6425L15.4875 20.6358C15.1654 20.3088 14.9847 19.8682 14.9843 19.4092V19.1068C14.9844 18.875 14.9384 18.6455 14.849 18.4317C14.7596 18.2178 14.6287 18.0238 14.4637 17.861L13.8283 17.2742C13.6125 17.0751 13.3502 16.9336 13.0654 16.8625C12.7806 16.7914 12.4825 16.793 12.1986 16.8673C11.7508 16.9842 11.2802 16.9819 10.8335 16.8608C10.3869 16.7396 9.97967 16.5038 9.65231 16.1766L4.98036 11.5041C2.2088 8.73256 1.18888 4.54732 3.14396 2.61084Z"
              stroke="black"
              strokeWidth="1.75"
              strokeLinejoin="round"
            />
            <path
              d="M21.8745 1.75L17.6499 5.97461C17.3248 6.29963 17.067 6.6855 16.891 7.11019C16.7151 7.53488 16.6245 7.99007 16.6245 8.44976V9.26242C16.6246 9.3774 16.6019 9.49126 16.5579 9.59748C16.5139 9.7037 16.4494 9.80021 16.368 9.88148L15.7495 10.5M17.4995 12.25L18.118 11.6315C18.1993 11.5502 18.2958 11.4856 18.4021 11.4416C18.5083 11.3976 18.6221 11.375 18.7371 11.375H19.5498C20.0095 11.375 20.4646 11.2844 20.8893 11.1085C21.314 10.9326 21.6999 10.6747 22.0249 10.3496L26.2495 6.125M24.062 3.9375L19.687 8.3125M10.937 20.125L5.48359 25.6091C5.07338 26.0192 4.51708 26.2495 3.93703 26.2495C3.35699 26.2495 2.80069 26.0192 2.39047 25.6091C1.98038 25.1988 1.75 24.6425 1.75 24.0625C1.75 23.4825 1.98038 22.9262 2.39047 22.5159L6.99953 17.9375"
              stroke="black"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_333_6881">
              <rect width="28" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <Typography
          fontSize={10}
          fontWeight="bold"
          color="black"
          sx={{ fontFamily: "'Poppins', sans-serif" }}
        >
          Nouveau restaurant
        </Typography>
      </Button>
      <Button
        variant="contained"
        sx={{
          padding: 0,
          borderRadius: "20px",
          paddingBottom: 1,
          paddingTop: 1,
          paddingLeft: 0.5,
          paddingRight: 0.5,
          backgroundColor: "#ffffff",
          marginTop: 1,
          marginBottom: 2,
          width: 160,
          "&:hover": {
            backgroundColor: "#A0E295",
          },
        }}
        onClick={OpenEmployee}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.0827 11.3333C24.0827 15.2455 20.9115 18.4167 16.9993 18.4167C13.0872 18.4167 9.91602 15.2455 9.91602 11.3333C9.91602 7.42121 13.0872 4.25 16.9993 4.25C20.9115 4.25 24.0827 7.42121 24.0827 11.3333ZM22.666 11.3333C22.666 12.8362 22.069 14.2776 21.0063 15.3403C19.9436 16.403 18.5022 17 16.9993 17C15.4965 17 14.0551 16.403 12.9924 15.3403C11.9297 14.2776 11.3327 12.8362 11.3327 11.3333C11.3327 9.83044 11.9297 8.3891 12.9924 7.32639C14.0551 6.26369 15.4965 5.66667 16.9993 5.66667C18.5022 5.66667 19.9436 6.26369 21.0063 7.32639C22.069 8.3891 22.666 9.83044 22.666 11.3333Z"
            fill="black"
          />
          <path
            d="M21.6038 19.8337C21.5285 19.8165 21.4495 19.8256 21.38 19.8593C21.3105 19.893 21.2545 19.9494 21.2213 20.0192L18.4163 28.0305V25.5003L18.009 22.6521C18.1391 22.6247 18.2588 22.5613 18.3545 22.4691C18.4502 22.3769 18.518 22.2597 18.5502 22.1308L18.9044 20.7141C18.9305 20.6097 18.9326 20.5008 18.9103 20.3955C18.888 20.2902 18.8421 20.1914 18.7759 20.1065C18.7098 20.0216 18.6251 19.953 18.5285 19.9057C18.4318 19.8584 18.3256 19.8338 18.218 19.8337H15.7828C15.6752 19.8337 15.569 19.8582 15.4723 19.9054C15.3756 19.9526 15.2909 20.0212 15.2247 20.106C15.1585 20.1908 15.1124 20.2896 15.0901 20.3948C15.0677 20.5001 15.0696 20.609 15.0957 20.7134L15.4498 22.1301C15.482 22.2591 15.5497 22.3765 15.6454 22.4688C15.7411 22.5612 15.8609 22.6247 15.991 22.6521L15.583 25.5003V27.41L12.778 20.0192C12.7448 19.9494 12.6889 19.893 12.6193 19.8593C12.5498 19.8256 12.4709 19.8165 12.3955 19.8337C12.1247 19.899 11.8537 19.9633 11.5823 20.0263C9.98009 20.4017 7.99959 20.865 6.94701 21.5563C5.69822 22.3759 4.95801 23.342 4.95801 24.4378V29.042H29.0413V24.4378C29.0413 23.342 28.3011 22.3766 27.0523 21.5563C25.9998 20.865 24.0193 20.4017 22.417 20.0263C22.1316 19.9597 21.8574 19.896 21.6038 19.8337Z"
            fill="black"
          />
        </svg>

        <Typography
          fontSize={10}
          fontWeight="bold"
          color="black"
          sx={{ fontFamily: "'Poppins', sans-serif" }}
          mx={1}
        >
          Nouveau employé
        </Typography>
      </Button>
      <Dialog open={isDialogOpen} onClose={CloseEmployee}>
        <NewEmployee onCancel={CloseEmployee} />
      </Dialog>
    </Box>
  );
}
